export const listTypes = {
	TABLE: 'TABLE',
	LARGE: 'LARGE',
	COLLAPSIBLE_PANEL: 'COLLAPSIBLE_PANEL',
};

export const cellTitleDisplayModes = {
	TITLE_MODE_TEXT: 'text',
	TITLE_MODE_INPUT: 'input',
};

export const SORT_BY = {
	ASC: 'ASC',
	DESC: 'DESC',
};

export const SELECTION_MODE = {
	MULTI: 'MULTI',
	SINGLE: 'SINGLE',
};

export const internalIds = {
	rowSelector: 'tc-list-internal-row-selector',
};
